export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=16789721&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/axoft-maximum-pro/index.vue?vue&type=template&id=16789721&
// module id = 1311
// module chunks = 0